import frTranslations from "../languages/fr.json";
import esTranslations from "../languages/es.json";
import enTranslations from "../languages/en.json";

document.addEventListener("DOMContentLoaded", async () => {
  const defaultLang = "fr";
  const savedLang = localStorage.getItem("selectedLanguage");
  const currentLang = savedLang || defaultLang;
  const langSwitcherBtns = document.querySelectorAll(".lang-switch");

  const useCorrectTranslation = (lang) => {
    const translations_map = {
      fr: frTranslations,
      es: esTranslations,
      en: enTranslations,
    };

    const translationsData = translations_map[lang];

    const translations = document.querySelectorAll("[data-translation]");

    translations.forEach((translation) => {
      const key = translation.dataset.translation;

      if (translationsData[key]) {
        translation.textContent = translationsData[key];
      }
    });

    const resumeLinks = document.querySelectorAll(".resume-link");

    resumeLinks.forEach(function (resumeLink) {
      resumeLink.href = `img/cv-fiona-perina-${lang}.pdf`;
    });
  };

  useCorrectTranslation(currentLang);

  // renommer cette classe btn ?
  langSwitcherBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const newLang = btn.dataset.lang;
      localStorage.setItem("selectedLanguage", newLang);
      useCorrectTranslation(newLang);
    });
  });

  document.querySelector(".go-back").addEventListener("click", () => {
    history.back();
  });

  var currentLangHeader = document.querySelector(".current-lang");
  var langOptionsWindow = document.querySelector(".lang-options-window");
  // var toggleMenu = function toggleMenu() {
  //   langOptionsWindow.classList.toggle("is-active");
  // };
  // currentLangHeader.addEventListener("click", toggleMenu);

  //MENU MOBILE
  var burgerMenuMobile = document.querySelector(".burger-menu-mobile");
  var menuMobile = document.querySelector(".menu-mobile");
  var crossClose = document.querySelector(".cross-close");
  var langCrossClose = document.querySelector(".lang-cross-close");
  var headerMobile = document.querySelector(".header-mobile");

  if (burgerMenuMobile) {
    burgerMenuMobile.addEventListener("click", function () {
      menuMobile.classList.add("is-active");
      headerMobile.classList.add("is-active");
    });
  }
  if (crossClose) {
    crossClose.addEventListener("click", function () {
      menuMobile.classList.remove("is-active");
      headerMobile.classList.remove("is-active");
    });
  }

  if (currentLangHeader) {
    currentLangHeader.addEventListener("click", function () {
      langOptionsWindow.classList.add("is-active");
    });
  }

  if (langCrossClose) {
    langCrossClose.addEventListener("click", function () {
      langOptionsWindow.classList.remove("is-active");
    });
  }

  // if (langSwitcherBtns) {
  //   langSwitcherBtns.addEventListener("click", function () {
  //     langOptionsWindow.classList.remove("is-active");
  //   });
  // }
});

//LIGHTBOX

document.addEventListener("DOMContentLoaded", () => {
  const lightbox = document.getElementById("lightbox");
  const lightboxImg = lightbox.querySelector(".lightbox-img");
  const closeBtn = lightbox.querySelector(".lightbox-close");
  const prevBtn = lightbox.querySelector(".lightbox-prev");
  const nextBtn = lightbox.querySelector(".lightbox-next");
  const overlay = lightbox.querySelector(".lightbox-overlay");

  // Toutes les images cliquables (main + thumbs)
  const images = Array.from(
    document.querySelectorAll(
      ".mySwiper2 .swiper-slide img, .mySwiper .swiper-slide img"
    )
  );

  // éviter les doublons (swiper duplique avec loop)
  const uniqueImages = [];
  const srcSet = new Set();

  images.forEach((img) => {
    if (!srcSet.has(img.src)) {
      srcSet.add(img.src);
      uniqueImages.push(img);
    }
  });

  let currentIndex = 0;

  const openLightbox = (index) => {
    currentIndex = index;
    lightboxImg.src = uniqueImages[currentIndex].src;
    lightbox.classList.add("is-active");
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    lightbox.classList.remove("is-active");
    document.body.style.overflow = "";
  };

  const showPrev = () => {
    currentIndex =
      (currentIndex - 1 + uniqueImages.length) % uniqueImages.length;
    lightboxImg.src = uniqueImages[currentIndex].src;
  };

  const showNext = () => {
    currentIndex = (currentIndex + 1) % uniqueImages.length;
    lightboxImg.src = uniqueImages[currentIndex].src;
  };

  uniqueImages.forEach((img, index) => {
    img.style.cursor = "zoom-in";
    img.addEventListener("click", () => openLightbox(index));
  });

  closeBtn.addEventListener("click", closeLightbox);
  overlay.addEventListener("click", closeLightbox);
  prevBtn.addEventListener("click", showPrev);
  nextBtn.addEventListener("click", showNext);

  // clavier
  document.addEventListener("keydown", (e) => {
    if (!lightbox.classList.contains("is-active")) return;

    if (e.key === "Escape") closeLightbox();
    if (e.key === "ArrowLeft") showPrev();
    if (e.key === "ArrowRight") showNext();
  });
});
